import QRCode, { QRCodeCanvas } from "qrcode.react";
import {
  multiFactor,
  TotpMultiFactorGenerator,
  TotpSecret,
} from "firebase/auth";
import { useAuth } from "../../../firebase/AuthProvider";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const MfaSetupPage = () => {
  const { currentUser } = useAuth();
  const [secret, setSecret] = useState<TotpSecret | null>(null);
  const [uri, setUri] = useState("");
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const prepare = async () => {
      if (!currentUser) return;
      const mfUser = multiFactor(currentUser);
      const session = await mfUser.getSession();
      const totpSecret = await TotpMultiFactorGenerator.generateSecret(session);

      setSecret(totpSecret);
      setUri(
        `otpauth://totp/Sprout%20App:${currentUser.email}?secret=${totpSecret.secretKey}&issuer=Sprout%20App`
      );
    };
    prepare();
  }, [currentUser]);

  const enroll = async () => {
    if (!secret || !currentUser) return;
    const assertion =
      TotpMultiFactorGenerator.assertionForEnrollment(secret, code);
    await multiFactor(currentUser).enroll(assertion, "Authenticator App");
    navigate("/home");
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 text-center">
            Enable 2-Step Verification
          </h1>
          <p className="mt-2 text-sm text-gray-600 text-center">
            Scan this QR code with Google Authenticator, Authy, etc.
          </p>
        </div>

        <div className="flex justify-center">
          {uri && <QRCodeCanvas value={uri} size={200} />}
        </div>

        <div className="mt-6">
          <label htmlFor="code" className="block text-sm font-medium text-gray-700">
            Verification Code
          </label>
          <div className="mt-1">
            <input
              id="code"
              type="text"
              value={code}
              onChange={(e) => {
                const digitsOnly = e.target.value.replace(/\D/g, "").slice(0, 6);
                setCode(digitsOnly);
              }}
              placeholder="Enter 6-digit code"
              className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
              maxLength={6}
              inputMode="numeric"
            />
          </div>
        </div>

        <div className="mt-8">
          <button
            disabled={busy}
            onClick={enroll}
            className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            Activate MFA
          </button>
        </div>
      </div>
    </div>
  );
};

export default MfaSetupPage;